import { Injectable } from '@angular/core';
import { ConfigurationManagerService } from './configuration-manager.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {


  apiKey: string = ConfigurationManagerService.settings.BaseURL;

  constructor(private http: HttpClient) { }

  post(path: string, body: any): Promise<any> {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
            
    };
  
    
    return this.http.post<any>(path, body,{ headers: headersConfig }).toPromise();
  }
  get(path: string): Promise<any> {
    const headersConfig = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'APIKey': this.apiKey,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type,  X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Date, X-Api-Version, X-File-Name',
      
    };
    return this.http.get<any>(path,{ headers: headersConfig }).toPromise();
  }

  httpget(path: string): Promise<any> {
    const headerDict = {
     
    }
   

    const httpHeaders: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'APIKey':this.apiKey,

  });
    return this.http.get<any>(path,{ headers: httpHeaders }).toPromise();
  }

  httpLoginget(path: string,username: string,password: string): Promise<any> {
    
      const httpHeaders: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': '*/*',
      'Authorization': 'Basic ' + btoa(username + ':' + password)

  });
    return this.http.get<any>(path,{ headers: httpHeaders }).toPromise();
  }
}
